export default `
<style>
    .osrm-print__section{
      display: block;
      width: 100%;
      border-bottom: 1px solid rgba(200,200,200,0.6);
      padding: 10px 15px 10px 10px;
    }
    .osrm-print__section__icon{
      display: inline;
      float: left;
      width: 36px;
      height: 36px;
      padding: 0 3px;
    }
    .osrm-print__section__instruction{
      display: inline;
      float: left;
      width: calc(100% - 52px);
      min-height: 36px;
      padding-left: 4px;
    }
    .osrm-print__section__duration{
      display: block;
      clear: left;
      width: 100%;
      text-align: right;
      font-size: 0.8em !important;
      font-style: italic;
      padding-top: 4px;
    }
  </style>
`;
